module.exports = __webpack_public_path__ + "img/CAPT_Albay.cf359553.jpg";